import styled from 'styled-components'

export const FormErrorMessage = styled.div`
  font-size: 10px;
  color: #fe6969;
  margin-top: 3px;
  padding-top: 0!important; 
`
